import { render, staticRenderFns } from "./synchronize.vue?vue&type=template&id=4b87bc7a&"
import script from "./synchronize.vue?vue&type=script&lang=js&"
export * from "./synchronize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports